<template>
  <div class="dljsgcjnpgf">
    <div class="calc-templete">
      <h6>全国电力建设工程建设项目规划选址费计算模版</h6>
      <t-form :data="formData" :rules="rules" ref="form" @reset="onReset" @submit="onSubmit">
        <t-row style="height: auto;align-items: stretch;">
          <t-col :span="6"
            style="border-right: 1px solid #DADDE1;padding-left: 40px;padding-right: 140px;padding-bottom: 50px;height: auto;">
            <div class="left-top-title"><span>燃气-蒸汽联合循环电站</span></div>
            <t-form-item label="计算依据">
              <a class="file-name" v-if="fileList" @click="fileOpenDialog(fileList.url)">{{ fileList.fileName }}</a>
              <a v-else class="no-file-name">无文件</a>
              <!-- <t-input v-model="formData.projectName" placeholder="请输入工程名称" ></t-input> -->
            </t-form-item>
            <t-form-item label="工程名称" name="projectName">
              <t-input v-model="formData.projectName" placeholder="请输入工程名称"></t-input>
            </t-form-item>

            <t-form-item label="电站个数" name="money">
              <t-input-number v-model="formData.money" placeholder="请输入电站个数" suffix="个" type="number" :min="0" theme="normal"></t-input-number>
            </t-form-item>

            <t-form-item label="细分类型" name="subcategor">
              <!-- <t-input v-model="formData.subcategor" placeholder="请输入细分类型"></t-input> -->
              <t-select v-model="formData.subcategor" placeholder="请输入细分类型" @change="changeSubcategor" default-value="200">
          <t-option key="9E级" label="9E级" value="9E" />
          <t-option key="9F级"  label="9F级" value="9F"></t-option>

        </t-select>
              <t-popup placement="right" showArrow>
                <template #content>
                  <div>请确定好计算的类型</div>
                </template>
                <t-button theme="default" variant="outline" class="coefficient">查看说明
                </t-button>
              </t-popup>
            </t-form-item>

            <t-form-item label="费用基价(万元)" name="costBasePrice">
              <t-input v-model="formData.costBasePrice" placeholder="请输入费用基价(万元)" :status="inputStatus" :tips="tips" type="number"></t-input>
                <t-button theme="default" variant="outline" class="coefficient"><span>{{ costBasePriceLimit }}</span>
                </t-button>
            </t-form-item>

            <t-form-item label="调整系数" name="coefficient">
              <t-input v-model="formData.coefficient" placeholder="调整系数" :status="inputStatus3" :tips="tips3"></t-input>
              <t-popup placement="right" showArrow>
                <template #content>
                  <div>
                    默认：1.0<br/>
                    注1(火力)：<br/>
                    1.扩建工程不计列此项费用。<br/>
                    2.其他容量等级发电机组可结合实际情况参照执行。<br/>
                    注2(电力)：<br/>
                    1.扩建工程不计列此项费用。<br/>
                    2.±500kV及以下直流背靠背、柔性直流工程等，参照±500kV直流工程计取。<br/>
                    3.若500kV及以上输变电工程需经过多个地级市，增加费用即可根据工程实际情况协商确定。
                  </div>
                </template>
                <t-button theme="default" variant="outline" class="coefficient">查看说明
                  <img src="@/assets/icon/Vector.svg"
                    style="width: 4px;height: 7px;left: 4px;top: 8px;position: relative;">
                </t-button>
              </t-popup>
            </t-form-item>

            <t-form-item label="让利利率" name="discountRate">
              <t-input-number v-model="discountRate" placeholder="" label="-" suffix="%" :min="0" :max="100" theme="normal"/>
            </t-form-item>
            <t-button theme="primary" type="submit" class="submit">点击计算（消耗2积分）</t-button>
          </t-col>
          <t-col :span="6" style="padding-left: 106px;padding-right: 70px;padding-bottom: 50px;">
            <div class="right-top-title"><span>计算结果</span></div>
            <t-form-item label="收费基价" name="subtotal">
              <t-input v-model="formData.subtotal" placeholder="" disabled suffix="元"></t-input>
            </t-form-item>
            <t-form-item label="基本收费" name="basicCharge">
              <t-input v-model="formData.basicCharge" placeholder="" disabled suffix="元"></t-input>
            </t-form-item>
            <t-form-item label="选  址 费" name="assessmentFee">
              <t-input v-model="formData.assessmentFee" placeholder="" disabled suffix="元"></t-input>
            </t-form-item>
            <t-form-item label="计算过程">
              <t-textarea v-model="jsgc" placeholder="" disabled :autosize="{ minRows: 3, maxRows: 5 }"></t-textarea>
            </t-form-item>

            <t-form-item label="折后选址费" name="result">
              <t-input v-model="formData.result" placeholder="" disabled suffix="元" @change="resultChange"></t-input>
            </t-form-item>
            <t-form-item label="金额大写" name="resultChinese">
              <t-input v-model="resultChinese" placeholder="" disabled></t-input>
            </t-form-item>

            <t-button class="download" @click="downLoadWord" :disabled="!formData.result"
            :loading="downLoading">查看计算过程和报告（消耗5积分）</t-button>
          </t-col>
        </t-row>





        <!-- 
        <t-form-item style="margin-left: 140px">
          <t-row>
            <t-col :span=12>
              <t-space size="10px">
                
                

              </t-space>
            </t-col>
            <t-col :span=12 style="margin-top: 10px;">
              <t-button theme="default" variant="base" @click="handleClear" class="help">是否需要详细过程？给点小费求助·</t-button>
            </t-col>
          </t-row>



        </t-form-item> -->
      </t-form>

    </div>
    <div class="calc-rules">
      <t-row>
        <t-col :span="6" style="border-right: 1px solid #DADDE1;">
          <h4><span>计算范围和计算公式</span></h4>
        </t-col>
        <t-col :span="6">
          <h4><span>费率标准</span></h4>
        </t-col>
      </t-row>
      <div class="calc-rules-value">
         <t-row style="height: auto; align-items: stretch;">
          <t-col :span="6" style="border-right: 1px solid #DADDE1;">
            <div class="calc-rules-value-left">
              <div class="title"><span>计算范围</span></div>
              <div class="info">{{ calculateRange }}</div>
              <div class="title" style="margin-top: 33px;"><span>计算公式</span></div>
              <div class="info" style="white-space: pre-line;" >{{ calculationFormula }}</div>
            </div>
          </t-col>
          <t-col :span="6" style="padding: 20px;overflow: auto;" class='rate-table'>
            <div class="calc-rules-value-right">
              <t-table bordered row-key="index" :data="data" :columns="columns" />
            </div>
          </t-col>
        </t-row>
      </div>
    </div>
    <!-- <help v-bind:visible.sync="helpOpen"></help> -->
    <file-view v-bind:visible.sync="visible" :fileUrl="openFileUrl" :downFileUrl="downFileUrl"></file-view>
  </div>
</template>

<script>
import { getdljsgcjnpgf } from '@/api/data'
import { listFile } from "@/api/file";
import { listRate } from "@/api/rate";
// import Help from '@/components/Help.vue'

export default {
  name: 'rqzqlhxhdzFee',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    // Help
  },
  data() {
    return {
      jsgc: null,
      visible: false,
      downFileUrl: null,
      openFileUrl: null,
      downLoading: false,
      validateMessage: {
        projectName: [
          {
            type: 'error',
            message: '项目名称不能为空',
          },
        ],
        money: [
          {
            type: 'error',
            message: '请输入规范数字',
          },
        ]

      },
      rules: {
        projectName: [{ required: true }, { type: 'warning' }],
        money: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }],


      },
      helpOpen: false,
      rate: null,
      discountRate: null,
      downData: {},//下载时传值
      rateList: [],
      formData: {
        ificationId: this.$route.query.ification,
        projectName: '',
        projectType:'',
        money: null, //长度和个数
        subcategor: '9E级', //细分类型
        costBasePrice: '15', // 费用基价
        costper: null, // 超范围每增加1km费用(万元)
        coefficient: '1.0',  // 调整系数
        rate: null,
        subtotal: null, // 收费基价
        discountRate: 0,
        discountRateMoney: null,
        basicCharge:null,//基本收费
        assessmentFee:null,//选  址 费
        result: null,
        remark: 1
      },
      resultChinese: '',
      fileList: [],
      costBasePriceLimit:'5~15',
      costBasePriceMin:5,
      costBasePriceMax:15,
      data: [{

      }],

      columns: [
        {
          title: '序',
          colKey: 'id',
          width: 90,
        },
        {
          title: '收费区间值（万元）',
          width: 100,
          colKey: '-',
          children: [
            {
              colKey: 'startValue',
              title: '起值',
              width: 100,
            },
            {
              title: '终止',
              colKey: 'finalValue',
              width: 100,
            }
          ],
        },
        {
          title: '费率',
          colKey: 'rate',
          width: 100,
        }


      ],
      calculateRange:null,//计算范围
      calculationFormula:null // 计算公式


    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      listFile({ classificationId: this.$route.query.ification }).then(response => {
        // console.log(response)
        this.fileList = response.rows[0];

      });
      listRate({ ificationId: this.$route.query.ification }).then(res => {
        let i = 1
        res.rows.forEach((item) => {
          item.id = i++
          if (item.finalValue > 99999999) {
            item.finalValue = ""
          }
          this.data.push(item)
        })
        this.data = res.rows
      })
      this.getClassification(this.$route.query.ification || 3).then(res => {
        if(res.data.scope){
          if (res.data.scope.indexOf("\\n")!=-1){
            this.calculateRange = res.data.scope.replaceAll('\\n', '\n')
          }else{
            this.calculateRange = res.data.scope
          }
          
        }else{
          this.calculateRange = '暂无数据'
        }
        if(res.data.particulars){
          if (res.data.particulars.indexOf("\\n")!=-1){
            this.calculationFormula = res.data.particulars.replaceAll('\\n', '\n')
          }else{
            this.calculationFormula = res.data.particulars
          }
        }else{
          this.calculationFormula = '暂无数据'
        }
      })
    },
    onReset() {
      this.$message.success('重置成功');
      console.log('formData', this.formData);
    },
    onSubmit({ validateResult, firstError }) {
      if (validateResult === true) {
        this.submit()
        this.$message.success('提交成功');
      } else {
        console.log('Errors: ', validateResult);
        this.$message.warning(firstError);
      }
    },
    downLoadWord() {
      this.downLoading = true;
      let wordParam = {
        xmmc: this.formData.projectName,
        xsz: `电站个数:${this.formData.money}个;细分类型:${this.formData.subcategor}级;费用基价:${this.formData.costBasePrice}万元;调整系数:${this.formData.coefficient};让利利率:${this.discountRate}%。`,
        yjwj: this.fileList ? this.fileList.fileName.split('.')[0] : '--',

        tzxs:this.formData.coefficient,
        gcfl:'火力发电工程',
        gclx:'燃气-蒸汽联合循环电站',

        jsgc: this.jsgc,
        zhj: this.formData.result,
      }
      this.download('/project/dljsgcshwdfxpgf/word', { id: this.downData.id, classId: 61, ...wordParam }
        , `全国电力建设工程建设项目规划选址费.docx`).then(res => {
          console.log(res)
          this.downLoading = false
        }
        )
    },
    handleClear() {
      this.helpOpen = true
    },
    submit() {
      this.formData.remark = 1
      this.formData.rate = Number(this.rate) / 100
      this.formData.discountRate = Number(this.discountRate) / 100
      getdljsgcjnpgf(this.formData).then(res => {
        this.downData = res.data
          this.formData.money = res.data.money.toString()
        this.formData.discountRateMoney = res.data.discountRateMoney.toFixed(2).toString()
        this.formData.result = res.data.result.toFixed(2).toString()
        this.formData.subtotal = res.data.subtotal.toFixed(2).toString()
        this.formData.basicCharge = res.data.basicCharge.toFixed(2).toString()
        this.formData.assessmentFee = res.data.assessmentFee.toFixed(2).toString()
        // this.formData.money.toString()
        this.resultChinese = this.changeNumMoneyToChinese(Number(this.formData.result))
        this.jsgc = res.data.jsgc
      })
    },
    resultChange(value) {
      this.resultChinese = this.changeNumMoneyToChinese(value)
    },
    changeSubcategor(value){
      console.log(value)
      if (value == '9E'){
        this.costBasePriceLimit='5~15'
        this.costBasePriceMin=5,
        this.costBasePriceMax=15,
        this.formData.costBasePrice = '15'
      }else if (value == '9F') {
        this.costBasePriceLimit='10~25'
        this.costBasePriceMin=10,
        this.costBasePriceMax=25,
        this.formData.costBasePrice = '25'
      }
    },

  },
  computed: {
    inputStatus() {
      if (this.formData.costBasePrice < this.costBasePriceMin || this.formData.costBasePrice > this.costBasePriceMax ) {
        return 'error';
      }if (isNaN(+this.formData.costBasePrice)){
        return 'warning';
      }
      return '';
    },
    tips() {
      if (this.inputStatus == 'error') {
        return '请输入合理区间数字';
      }else if(this.inputStatus == 'warning') {
        return '请输入规范数字';
      }
      return '';
    },
    inputStatus2() {
      if (isNaN(+this.discountRate)) {
        return 'error';
      }
      return '';
    },
    tips2() {
      if (!this.inputStatus2) {
        return '';
      }
      return '请输入数字';
    },
    inputStatus3() {
      if (isNaN(+this.formData.coefficient)) {
        return 'error';
      }
      return '';
    },
    tips3() {
      if (!this.inputStatus3) {
        return '';
      }
      return '请输入数字';
    },
  },

}
</script>

<style lang="less" >
.dljsgcjnpgf {
  background: #ffffff;
  width: 1168px;
  margin: 0 auto;
  border: 1px solid #e3e6ea;
  padding-bottom: 38px;


  

  

  
}</style>
